import { Divider, Paper } from '@mui/material';
import { ImportsData } from './importsData';
import { PopperHeader } from './popperHeader';
import { ResetReadImports } from './resetReadImports';
import * as Styled from './styled';

export const ImportPopper = ({
  anchorEl,
  setImportPopperOpened,
}: {
  anchorEl: HTMLElement | null;
  setImportPopperOpened: (status: boolean) => void;
}) => {
  return (
    <Styled.Popper
      id={'import-temporal-popper'}
      open={!!anchorEl}
      anchorEl={anchorEl}
      placement="bottom-end"
    >
      <Paper elevation={8}>
        <PopperHeader setImportPopperOpened={setImportPopperOpened} />

        <Divider />

        <ImportsData setImportPopperOpened={setImportPopperOpened} />

        <Divider />

        <ResetReadImports />
      </Paper>
    </Styled.Popper>
  );
};
